import React from 'react'
import { useTranslation } from 'react-i18next'

import { HistoryDrawer } from '@/features/audit/components/HistoryDrawer'
import { EntityHistoryType, useEntityHistory } from '@/features/audit/hooks'

interface CompanyHistoryDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  entityId: string
}

const CompanyHistoryDrawer: React.FC<CompanyHistoryDrawerProps> = ({
  open,
  onOpenChange,
  entityId,
}) => {
  const { t } = useTranslation()

  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useEntityHistory(EntityHistoryType.COMPANY, entityId, open)

  // Flatten all pages into a single entries array
  const entries = data?.pages.flatMap((page) => page.data) ?? []

  return (
    <HistoryDrawer
      open={open}
      onOpenChange={onOpenChange}
      title={t('company.actions.history')}
      entries={entries}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
    />
  )
}

export default CompanyHistoryDrawer
